import React, { createContext, useContext, useState, ReactNode } from "react";

interface HeaderConfig {
  title: string;
  actions: ReactNode | null;
}

interface HeaderContextType {
  headerConfig: HeaderConfig;
  setHeaderConfig: (config: HeaderConfig) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [headerConfig, setHeaderConfig] = useState<HeaderConfig>({
    title: "",
    actions: null,
  });

  return (
    <HeaderContext.Provider value={{ headerConfig, setHeaderConfig }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (!context) {
    console.warn("[useHeader] HeaderProvider not found, using default values");
    // Return default values instead of throwing to prevent crashes
    return {
      headerConfig: {
        title: "",
        actions: null,
      },
      setHeaderConfig: () => {
        console.warn(
          "[useHeader] setHeaderConfig called but HeaderProvider not available",
        );
      },
    };
  }
  return context;
};
